// Application version
export const APPLICATION_VERSION = "27.0.1";
